import { Button, Text } from '@/components'
import {
  selectInProgressUnenrollment,
  setFeedback,
} from '@/reducers/inProgressUtilityProgramUnenrollments'
import * as Yup from 'yup'
import { useUnenrollmentRouteContext } from '..'
import { useNavigation } from '@/app/hooks'
import { useAppDispatch, useAppSelector } from '@/hooks'
import TextAreaFormField from '@/components/forms/text-area-form-field'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
const validationSchema = Yup.object({
  feedback: Yup.string().min(1).required('Feedback is required'),
})
type FormValues = Yup.InferType<typeof validationSchema>
function useViewModel() {
  const { utilityProgram } = useUnenrollmentRouteContext()
  const inProgressUnenrollment = useAppSelector(
    selectInProgressUnenrollment(utilityProgram.id),
  )
  const navigate = useNavigation()
  const dispatch = useAppDispatch()
  const onSubmit = (values: FormValues) => {
    dispatch(
      setFeedback({
        utilityProgramId: utilityProgram.id,
        feedback: values.feedback,
      }),
    )

    navigate.push(`/utility-program/${utilityProgram.id}/unenroll/review`)
  }
  const form = useForm<FormValues>({
    defaultValues: { feedback: inProgressUnenrollment?.feedback },
    resolver: yupResolver(validationSchema),
  })
  return {
    onSubmit,
    form,
  }
}
export default function UnenrollmentFeedback() {
  const { onSubmit, form } = useViewModel()
  const {
    register,
    formState: { isValid },
    handleSubmit,
  } = form
  return (
    <form
      className="flex flex-col gap-4 h-full"
      onSubmit={handleSubmit(onSubmit)}
    >
      <Text variant="h3">
        What can we do better?<span className="text-red-500">*</span>
      </Text>
      <TextAreaFormField
        name="feedback"
        label="Feedback"
        placeholder="Please tell us more about the issue(s) you encountered so that we can enhance our services for future users."
        required={true}
        register={register}
        textareaSize={'lg'}
      />
      <span className="flex-auto"></span>
      <Button id="unenroll-feedback-next" disabled={!isValid} type="submit">
        Continue
      </Button>
    </form>
  )
}
